var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup13009(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 557,
    height: 519,
    viewBox: "0 0 557 519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.957 0.5V63.6064L193.105 63.7539L277.854 147.521L278.205 147.867L278.556 147.521L363.563 63.7539L363.713 63.6074V0.5H432.521V91.7041L278.205 243.977L124.148 91.7051V0.5H192.957Z",
    stroke: "url(#paint0_linear_8159_19310)",
    strokeOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.713 455.023L363.564 454.876L278.815 371.109L278.464 370.763L278.112 371.109L193.106 454.876L192.957 455.022V518.13H124.148V426.925L278.463 274.905L432.521 426.925V518.13H363.713V455.023Z",
    stroke: "url(#paint1_linear_8159_19310)",
    strokeOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M556.166 107.951V175.696H492.318L492.172 175.841L407.423 259.862L407.065 260.218L407.423 260.572L492.172 344.594L492.318 344.738H556.166V412.483H463.879L309.827 260.217L463.879 107.951H556.166Z",
    stroke: "url(#paint2_linear_8159_19310)",
    strokeOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7861 107.951L246.838 260.471L92.7871 412.483H0.5V344.738H64.3467L64.4932 344.595L149.242 260.827L149.601 260.473L149.243 260.117L64.4941 175.842L64.3477 175.696H0.5V107.951H92.7861Z",
    stroke: "url(#paint3_linear_8159_19310)",
    strokeOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8159_19310",
    x1: 278.335,
    y1: 0,
    x2: 278.335,
    y2: 244.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8159_19310",
    x1: 278.335,
    y1: 274.204,
    x2: 278.335,
    y2: 518.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8159_19310",
    x1: 432.891,
    y1: 107.451,
    x2: 432.891,
    y2: 412.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8159_19310",
    x1: 123.775,
    y1: 107.451,
    x2: 123.775,
    y2: 412.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup13009);
export default __webpack_public_path__ + "static/media/Group 13009.a156b096b35e720a71d0887806a1c473.svg";
export { ForwardRef as ReactComponent };